<template>
  <UDashboardGroup class="bg-muted">
    <UDashboardSidebar
      class="border-default bg-default"
      :default-size="18"
      :max-size="26"
      :min-size="18"
      :ui="{ footer: 'border-t border-default' }"
      collapsible
      resizable
    >
      <template #toggle>
        <UDashboardSidebarToggle variant="subtle" />
      </template>
      <template #header="{ collapsed }">
        <RialticLogo
          v-if="!collapsed"
          class="h-8 dark:text-white"
          :icon="collapsed"
        />
        <div v-if="!collapsed" class="flex-1 px-2">
          <UBadge color="primary">Admin</UBadge>
        </div>
        <UDashboardSidebarCollapse
          class="translate-x-1 transform"
          :class="{ 'translate-x-2 transform': !collapsed }"
          variant="subtle"
        />
      </template>

      <template #default="{ collapsed }">
        <NavMenu :collapsed="collapsed" />
      </template>

      <template #footer="{ collapsed }">
        <UColorModeButton v-if="!collapsed" />

        <AuthState v-slot="{ loggedIn, user }">
          <NuxtLink v-if="!loggedIn" to="/auth/auth0" external>Login</NuxtLink>

          <UButton
            to="/profile"
            :label="collapsed ? undefined : user?.name"
            color="neutral"
            size="md"
            trailing
            variant="ghost"
          >
            <template #trailing>
              <UAvatar :src="user?.picture" size="sm" />
            </template>
          </UButton>
        </AuthState>
      </template>
    </UDashboardSidebar>

    <div class="w-full overflow-auto">
      <UDashboardNavbar class="visible lg:hidden" />
      <slot />
    </div>
  </UDashboardGroup>
</template>
